import { DataExtractionValueBase } from './DataExtractionValueBase';

export const __typename = 'DataExtractionValueSingleSelectDto';
export class DataExtractionValueSingleSelect extends DataExtractionValueBase {
  constructor(data = {}) {
    super({ ...data, __typename });
    this.value = data.value ?? '';
  }
}
